import { motion, AnimatePresence } from 'framer-motion';
import { X, Menu } from 'lucide-react';

// motion.button биш motion.div ашиглах
const MenuToggle = ({ isOpen, toggle }) => (
  <motion.div
    id="menu-toggle"
    onClick={toggle}
    className="cursor-pointer focus:outline-none text-[#d9d9d9]"
    whileTap={{ scale: 0.9 }}
  >
    <AnimatePresence initial={false} mode="wait">
      {isOpen ? (
        <motion.div
          key="close"
          initial={{ opacity: 0, rotate: -90 }}
          animate={{ opacity: 1, rotate: 0 }}
          exit={{ opacity: 0, rotate: 90 }}
          transition={{ duration: 0.2 }}
        >
          <X size={32} />
        </motion.div>
      ) : (
        <motion.div
          key="menu"
          initial={{ opacity: 0, rotate: 90 }}
          animate={{ opacity: 1, rotate: 0 }}
          exit={{ opacity: 0, rotate: -90 }}
          transition={{ duration: 0.2 }}
        >
          <Menu size={32} />
        </motion.div>
      )}
    </AnimatePresence>
  </motion.div>
);

export default MenuToggle;
